<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 510 - IMMUNIZATION REGISTER</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">🖨️ Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Immunizations</span>
        <span class="stat-number">{{ totalImmunizations }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Fully Immunized Children</span>
        <span class="stat-number">{{ fullyImmunized }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Defaulters</span>
        <span class="stat-number">{{ defaulters }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="immunization-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">Date</th>
            <th rowspan="2">Child's Name</th>
            <th rowspan="2">Date of Birth</th>
            <th rowspan="2">Age (months)</th>
            <th rowspan="2">Sex</th>
            <th rowspan="2">Mother's Name</th>
            <th rowspan="2">Contact</th>
            <th rowspan="2">SubLocation</th>
            <th colspan="5">Vaccines Given</th>
            <th rowspan="2">Next Appointment</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr>
            <th>BCG</th>
            <th>OPV</th>
            <th>DPT-HepB-Hib</th>
            <th>PCV</th>
            <th>Measles/Rubella</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.childName }}</td>
            <td>{{ record.dob }}</td>
            <td>{{ record.ageMonths }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.motherName }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td class="text-center">
              <span v-if="record.bcg" class="vaccine-given">✓</span>
              <span v-else class="vaccine-missing">-</span>
            </td>
            <td class="text-center">
              <span v-if="record.opv" class="vaccine-given">{{
                record.opv
              }}</span>
              <span v-else class="vaccine-missing">-</span>
            </td>
            <td class="text-center">
              <span v-if="record.dpt" class="vaccine-given">{{
                record.dpt
              }}</span>
              <span v-else class="vaccine-missing">-</span>
            </td>
            <td class="text-center">
              <span v-if="record.pcv" class="vaccine-given">{{
                record.pcv
              }}</span>
              <span v-else class="vaccine-missing">-</span>
            </td>
            <td class="text-center">
              <span v-if="record.measles" class="vaccine-given">✓</span>
              <span v-else class="vaccine-missing">-</span>
            </td>
            <td>{{ record.nextAppointment }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="16" class="empty-row">
              No immunization records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH510Immunization",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      immunizationRecords: [
        {
          date: "2026-04-22",
          childName: "Baby John Mwenda",
          dob: "2026-01-15",
          ageMonths: 3,
          sex: "M",
          motherName: "Mary Mwenda",
          contact: "0712345678",
          subLocation: "Kianjai",
          bcg: true,
          opv: "OPV1",
          dpt: "DPT1",
          pcv: "PCV1",
          measles: false,
          nextAppointment: "2026-05-22",
          remarks: "Well tolerated",
        },
        {
          date: "2026-04-22",
          childName: "Baby Grace Karimi",
          dob: "2025-10-10",
          ageMonths: 6,
          sex: "F",
          motherName: "Jane Karimi",
          contact: "0723456789",
          subLocation: "Mutuati",
          bcg: true,
          opv: "OPV3",
          dpt: "DPT3",
          pcv: "PCV3",
          measles: false,
          nextAppointment: "2026-05-22",
          remarks: "Growth normal",
        },
        {
          date: "2026-04-21",
          childName: "Baby Peter Kimathi",
          dob: "2025-08-05",
          ageMonths: 8,
          sex: "M",
          motherName: "Alice Kimathi",
          contact: "0734567890",
          subLocation: "Kangeta",
          bcg: true,
          opv: "OPV3",
          dpt: "DPT3",
          pcv: "PCV3",
          measles: true,
          nextAppointment: "2026-05-21",
          remarks: "Given measles vaccine",
        },
        {
          date: "2026-04-20",
          childName: "Baby Sarah Muthoni",
          dob: "2026-02-28",
          ageMonths: 1.5,
          sex: "F",
          motherName: "Grace Muthoni",
          contact: "0745678901",
          subLocation: "Laare",
          bcg: true,
          opv: "OPV0",
          dpt: false,
          pcv: false,
          measles: false,
          nextAppointment: "2026-05-20",
          remarks: "Birth dose given",
        },
        {
          date: "2026-04-19",
          childName: "Baby James Mwirigi",
          dob: "2025-11-15",
          ageMonths: 5,
          sex: "M",
          motherName: "Lucy Mwirigi",
          contact: "0756789012",
          subLocation: "Kianjai",
          bcg: true,
          opv: "OPV2",
          dpt: "DPT2",
          pcv: "PCV2",
          measles: false,
          nextAppointment: "2026-05-19",
          remarks: "Defaulted previous appointment",
        },
        {
          date: "2026-04-18",
          childName: "Baby Esther Kendi",
          dob: "2025-09-20",
          ageMonths: 7,
          sex: "F",
          motherName: "Ruth Kendi",
          contact: "0767890123",
          subLocation: "Mutuati",
          bcg: true,
          opv: "OPV3",
          dpt: "DPT3",
          pcv: "PCV3",
          measles: true,
          nextAppointment: "2026-05-18",
          remarks: "Fully immunized",
        },
        {
          date: "2026-04-17",
          childName: "Baby Samuel Mutuma",
          dob: "2026-03-01",
          ageMonths: 1.5,
          sex: "M",
          motherName: "Mercy Mutuma",
          contact: "0778901234",
          subLocation: "Kangeta",
          bcg: true,
          opv: "OPV1",
          dpt: "DPT1",
          pcv: "PCV1",
          measles: false,
          nextAppointment: "2026-05-17",
          remarks: "First visit",
        },
        {
          date: "2026-04-16",
          childName: "Baby Naomi Gacheri",
          dob: "2025-12-10",
          ageMonths: 4,
          sex: "F",
          motherName: "Hannah Gacheri",
          contact: "0789012345",
          subLocation: "Laare",
          bcg: true,
          opv: "OPV2",
          dpt: "DPT2",
          pcv: "PCV2",
          measles: false,
          nextAppointment: "2026-05-16",
          remarks: "Growing well",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.immunizationRecords;

      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }

      return filtered;
    },
    totalImmunizations() {
      let total = 0;
      this.filteredRecords.forEach((record) => {
        if (record.bcg) total++;
        if (record.opv) total++;
        if (record.dpt) total++;
        if (record.pcv) total++;
        if (record.measles) total++;
      });
      return total;
    },
    fullyImmunized() {
      return this.filteredRecords.filter((record) => {
        return (
          record.bcg &&
          record.opv === "OPV3" &&
          record.dpt === "DPT3" &&
          record.pcv === "PCV3" &&
          record.measles
        );
      }).length;
    },
    defaulters() {
      return this.filteredRecords.filter((record) => {
        return (
          record.remarks && record.remarks.toLowerCase().includes("default")
        );
      }).length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

/* Info Bar */
.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-print:hover {
  background: #2563eb;
}

/* Print Date Range */
.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

/* Summary Stats */
.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 15px 25px;
  text-align: center;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-number {
  display: block;
  font-size: 28px;
  font-weight: bold;
  color: white;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.immunization-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1300px;
}

.immunization-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.immunization-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.immunization-table td.text-center {
  text-align: center;
}

.vaccine-given {
  color: #059669;
  font-weight: bold;
  font-size: 12px;
}

.vaccine-missing {
  color: #9ca3af;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

/* Print Styles */
@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input,
  .month-select,
  .year-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .immunization-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .immunization-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .immunization-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }

  .stat-box {
    background: #1e3a5f !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
